export interface FundMemberDetailRequest {
    beginTime?: string
    current?: number
    endTime?: string
    accountId?: number
    size?: number
    tenantId?: number
    cameraId?: number
}

export interface FundMemberDetail {
    account: number
    amount: number
    cameraId: number
    createTime: string
    currency: string
    customerId: number
    debit: Debit
    fundAction: number
    fundType: FundType
    id: number
    lid: number
    payNo: string
    remark: string
    tenantId: number
    updateTime: string
    cameraIdStr: string
}

export enum Debit {
    ADD = 0,
    REDUCE = 1
}

export enum FundType {
    TENANT = 1,
    PERSONAL = 2,
    CASH = 3
}
